export { default as InstagramPostController } from './InstagramPost.controller'
